import React, { FC } from 'react';
import { TablesNames } from '../../store/tables/tables-context';
import { Table } from '../table/Table';
import { useMerchants } from '../../store/merchnts/merchants-context';
import { Title } from '../developers/page-components/Title';

interface Props {
	tableData: any
}

export const AccountDetailsMerchantsList: FC<Props> = (props) => {
	const { tableData } = props;
	const { merchantState: { isAccountListLoading }} = useMerchants();
	return (
		<div className="card px-8">
			<Table
				name={TablesNames.accountMerchantTableData}
				data={tableData ?? []}
				isLoading={isAccountListLoading}
				toolbarCustomAction={<Title title='Merchant list' additionalClass='fs-2'/>}
			/>
		</div>
	);
};
